module.exports = __webpack_public_path__ + "static/media/trees.2dc64ccb.svg";